import { render, staticRenderFns } from "./ConfirmBid.vue?vue&type=template&id=a18baa90"
import script from "./ConfirmBid.vue?vue&type=script&lang=js"
export * from "./ConfirmBid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports